// extracted by mini-css-extract-plugin
export const icon = "icon-module--icon--37cMe";